import { createSlice, createEntityAdapter } from "@reduxjs/toolkit"

import type { RootState } from "redux/store"
import {
  handleFetchPending,
  handleFetchRejected,
  handleFetchFulfilled,
} from "redux/helpers/fetching"
import { fetchSettings } from "redux/features/settings/settingsThunk"

const settingsAdapter = createEntityAdapter()
export const initialState = settingsAdapter.getInitialState({
  fetchStatus: {
    isFetching: false,
    isSuccess: false,
    isFailed: false,
  },
})

export const settingsSlice = createSlice({
  name: "settings",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchSettings.pending, (state) => handleFetchPending(state))
      .addCase(fetchSettings.rejected, (state) => handleFetchRejected(state))
      .addCase(fetchSettings.fulfilled, (state, { payload }) => {
        settingsAdapter.setAll(state, payload)
        handleFetchFulfilled(state)
      })
  },
})

export const { selectById: selectSettingsById, selectAll } =
  settingsAdapter.getSelectors((state: RootState) => state.features.settings)

export const selectFetchStatus = (state: RootState) =>
  state.features.settings.fetchStatus

export default settingsSlice.reducer
